export default "__VITE_ASSET__6938528d__"